(function () {
    function params() {
        if (typeof ghostMemberId !== 'undefined' && ghostMemberId) {
            localStorage.removeItem("ref");
            localStorage.removeItem("id");
            return;
        }
        const params = new URL(window.location.href).searchParams;
        const id = params.get("id");
        const ref = params.get("ref");
        const clear = params.get("clear");
        if (clear) {
            localStorage.removeItem("ref");
            localStorage.removeItem("id");
        }
        if (ref) {
            localStorage.setItem("ref", ref);
        }
        if (id) {
            localStorage.setItem("id", id);
        }
    }

    function init() {
        params();
        getAndRenderAds();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
